export const columnsTechniciansGroup = [
  {
    'Header': 'GRUPO',
    'accessor': 'groupId',
  },
  {
    'Header': 'DESCRIPCIÓN',
    'accessor': 'description',
  },
  {
    'Header': 'ÁREA',
    'accessor': 'area',
  },
  {
    'Header': 'ESTADO',
    'accessor': 'status',
  },
];

export const columnsTechnicians = [
  {
    'Header': 'GRUPO',
    'accessor': 'technicianId',
  },
  {
    'Header': 'DESCRIPCION',
    'accessor': 'description',
  },
  {
    'Header': 'ÁREA',
    'accessor': 'area',
  },
  {
    'Header': 'USUARIO',
    'accessor': 'relatedUser',
  },
  {
    'Header': 'INICIALES',
    'accessor': 'initials',
  },
  {
    'Header': 'NOMBRE',
    'accessor': 'name',
  },
  {
    'Header': 'TÉCNICO',
    'accessor': 'technician',
  },
  {
    'Header': 'ESTADO',
    'accessor': 'status',
  },
];

export const autoFields = ['description', 'area', 'initials', 'name'];
